// Module
var code = "<p><a href=\"/advisor\" target=\"_blank\">Explore a different repayment plan</a> for your federal loans.</p> ";
// Exports
export default code;